import React from "react";
import { useSelector } from "react-redux";
//import { AppealStatus } from "./AppealStatus";
import { BannedNav } from "./BannedNav";
import BannedPage from "./BannedPage";
import { BannedStatus } from "./BannedStatus";
import NewNavbar from "components/NavBar/NewNavbar";
import { sandooqTheme } from "themes/sandooqTheme";
import { ThemeProvider } from "@mui/material";

export const BannedHome = () => {
  // const { loading, appealStatus } = useSelector((state) => state.auth);

  return (
    <ThemeProvider theme={sandooqTheme}>
      <NewNavbar />
      <BannedPage />
    </ThemeProvider>
  );
};
